export default {
  sm: `
  네이버 데이터센터 각 로고입니다. 공식 표기 시
  ‘DATA CENTER GAK'의 위치는 로고 정가운데,
  지역명 표기 시 지역명과 함께 가운데 정렬로
  표시합니다.
  `,
  lg: `
  네이버 데이터센터 각 로고입니다.
  공식 표기 시 ‘DATA CENTER GAK'의 위치는 로고 정가운데,
  지역명 표기 시 지역명과 함께  가운데 정렬로 표시합니다.
  `
};
